import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined

const EditCompanySetup = () => {
    const { id } = useParams(); // Get the company ID from the URL
    const navigate = useNavigate();

    // State for holding the company data (removed 'id' from state)
    const [company, setCompany] = useState({
        name: '',
        code: '',
        address: '',
        country: '',
        state: '',
        city: '',
        pincode: '',
        phone: '',
        email: '',
        website: '',
        pan_no: '',
        tan: '',
        cin: '',
        gstin: '',
        establishment_code: '',
        esino: '',
        pfno: '',
        authorized_person: '',
        iec_code: '',
        gstn_username: '',
        gstn_password: '',
    });

    // Fetch company details on component mount
    useEffect(() => {
        fetch(`${BASE_URL}companysetup/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    setCompany(data.data);
                }
            })
            .catch((error) => console.error('Error fetching company details:', error));
    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();
    
        fetch(`${BASE_URL}companysetup/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(company),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                console.log("Response Data:", data); // Log the response data for debugging
                if (data.status === 'success') {
                    alert('Company updated successfully!');
                    navigate('/EditCompany/1'); // Assuming the route to list is `/CompanySetupList`
                } else {
                    alert('Error updating company. Please try again.');
                }
            })
            .catch((error) => {
                console.error('Error updating company:', error);
                alert('Error updating company. Please check the console for more details.');
            });
    };
    

    // Handle input change for all fields
    const handleChange = (e) => {
        const { name, value } = e.target;
        setCompany({ ...company, [name]: value });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Company Setup</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Company Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header"></div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {Object.keys(company).map((field) => (
                                        field !== 'id' && ( // Ensure 'id' field is not displayed
                                            <div className="mb-3" key={field}>
                                                <label htmlFor={field} className="form-label">
                                                    {field.replace(/_/g, ' ').toUpperCase()}
                                                </label>
                                                {field === 'address' ? (
                                                    <textarea
                                                        id={field}
                                                        name={field}
                                                        className="form-control"
                                                        value={company[field]}
                                                        onChange={handleChange}
                                                        placeholder={`Enter ${field.replace(/_/g, ' ')}`}
                                                    ></textarea>
                                                ) : (
                                                    <input
                                                        type={
                                                            field.includes('password')
                                                                ? 'password'
                                                                : field === 'email'
                                                                ? 'email'
                                                                : 'text'
                                                        }
                                                        id={field}
                                                        name={field}
                                                        className="form-control"
                                                        value={company[field]}
                                                        onChange={handleChange}
                                                        placeholder={`Enter ${field.replace(/_/g, ' ')}`}
                                                    />
                                                )}
                                            </div>
                                        )
                                    ))}
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">
                                            Update Company
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditCompanySetup;
